<template>
  <div class="publishPage">
    <div v-show="!showSelect">
      <div class="basic pad12">
        <div class="pubWorkerHeadTitle">
          <van-icon
            name="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_detail@2x.png"/>
          <span>招工详情</span>
        </div>
        <div class="projectContent">
          <van-field id="introFocus" v-model="form.intro" type="textarea" autosize maxlength="500" rows="5"
                     placeholder="请输入招工信息内容" @blur="typeOfWorkMatchMethod"
          />
          <div v-show="muBanIsShow && form.type !== '1'" class="muBanIsShow">
            <img
              src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_shangyige@2x.png"
              @click="shangyige">
            <img src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_xiayige@2x.png"
                 @click="xiayige">
          </div>
          <div :class="form.type == '1' ? 'btn_voiceBox' : 'btn_voiceStyle'">
            <van-button
              icon="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_muban@2x.png"
              round
              color="#37A1FF"
              @click="btn_muban"
              v-if="form.type !== '1' && !isClearMuban"
            >
              模版输入
            </van-button>
            <van-button
              icon="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_muban@2x.png"
              round
              color="#37A1FF"
              @click="btn_clearMuban"
              v-if="form.type !== '1' && isClearMuban"
            >
              清除模板
            </van-button>
            <van-button
              icon="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_yuyin@2x.png"
              round
              color="#096CEF"
              @click="btn_voice"
            >
              语音输入
            </van-button>
          </div>
        </div>
        <div class="pubWorkerHeadTitle" @click="upload">
          <van-icon
            name="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_shangchuan@2x.png"/>
          <span class="blue">照片、视频、文件</span>
        </div>
        <div style="display: flex">
          <div class="fileContainerBox" v-for="(item, index) in attachs" :key="index"
               @click="attDetail(item, index)">
            <div class="fileBox"
                 v-if="item.fileType ==='jpg' || item.fileType ==='png' || item.fileType ==='jpeg' || item.fileType ==='mp4'">
              <div style="position: relative">
                <div v-if="item.fileType ==='mp4'" class="videoBox">
                  <video :poster="item.attachUrl+'?x-oss-process=video/snapshot,t_1,m_fast'" :src="item.attachUrl"
                         class="video"></video>
                  <img src="../../assets/images/publicImg/icon_video_bg.png" class="file-img icon_video_bg">
                </div>
                <img class="file-img" :src="item.attachUrl"
                     v-if="item.fileType ==='jpg' || item.fileType ==='png' || item.fileType ==='jpeg'">
                <van-icon class="icon-attachDelete" :name="create_button_close" @click.stop="attachDelete(index)"/>
              </div>
            </div>
          </div>
        </div>
        <div class="fileContainer" v-for="(item, index) in attachs" :key="index"
             @click="attachsDetail(item.attachUrl)"
             v-if="item.fileType !=='jpg' && item.fileType !=='png' && item.fileType !=='jpeg' && item.fileType !=='mp4'">
          <span v-if="item.fileType ==='pdf'" class="icon_pdf"></span>
          <span v-else-if="item.fileType ==='xls' || item.fileType ==='xlsx'" class="icon_excel"></span>
          <span v-else-if="item.fileType ==='doc' || item.fileType ==='docx'" class="icon_word"></span>
          <span v-else-if="item.fileType ==='ppt' || item.fileType ==='pptx'" class="icon_ppt"></span>
          <span v-else class="icon_file_default"></span>
          <span class="attachName">{{ item.attachName }}</span>
          <van-icon class="icon-attachDelete" name="close" @click.stop="attachDelete(index)"/>
        </div>
      </div>
      <div class="basic inlineStyleBox pad12">
        <div class="fex">
          <van-icon
            name="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_didian@2x.png"/>
          <van-field v-model="addressName" label="招工地点：" right-icon="arrow" input-align="left"
                     readonly @click="btn_map"/>
        </div>
        <div class="fex" v-if="form.type == '2'" style="display: none;">
          <van-icon
            name="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_jiezhi@2x.png"/>
          <van-field v-model="form.validDaysText" label="报名截止：" right-icon="arrow"
                     input-align="left" readonly @click="validDaysMethods"/>
        </div>
        <div class="fex" style="display: none;">
          <van-icon
            name="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_liucheng@2x.png"/>
          <van-field v-model="form.typeText" label="招工流程：" right-icon="arrow" input-align="left"
                     readonly @click="assignProcess"/>
        </div>
        <div v-if="form.type !== '2'">
          <div class="fex">
            <van-icon
              name="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_fanwei@2x.png"/>
            <van-field v-model="form.companyRangeStr" label="投标范围：" right-icon="arrow" placeholder="请选择投标人范围"
                       input-align="left" readonly @click="toSelectCompany"/>
          </div>
          <div class="fex">
            <van-icon
              name="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_baomingkaishi@2x.png"/>
            <van-field v-model="form.signInBeginTime" label="报名开始：" right-icon="arrow" placeholder="请选择时间(必填)"
                       input-align="left" readonly @click="typeTime('signInBeginTime')"/>
          </div>
          <div class="fex" style="display: none;">
            <van-icon
              name="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_duixiang@2x.png"/>
            <van-field v-model="form.signInEndTime" label="报名截止：" right-icon="arrow" placeholder="请选择时间(必填)"
                       input-align="left" readonly @click="typeTime('signInEndTime')"/>
          </div>
          <div class="fex">
            <van-icon
              name="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_toubiaojiezhi@2x.png"/>
            <van-field v-model="form.tenderEndTime" label="投标截止：" right-icon="arrow" placeholder="请选择时间(必填)"
                       input-align="left" readonly @click="typeTime('tenderEndTime')"/>
          </div>
          <div class="fex">
            <van-icon
              name="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_kaibiaoshijian%20@2x.png"/>
            <van-field v-model="form.bidOpeningTime" label="开标时间：" right-icon="arrow" placeholder="请选择时间(必填)" readonly
                       input-align="left" @click="typeTime('bidOpeningTime')"/>
          </div>
          <div class="fex">
            <van-icon
              name="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_jihuashijian@2x.png"/>
            <van-field v-model="form.requiedFinishTime" label="计划完工：" right-icon="arrow" placeholder="请选择时间"
                       input-align="left" readonly @click="typeTime('requiedFinishTime')"/>
          </div>
        </div>
        <div v-else>
          <div class="fex">
            <van-icon
              name="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_gongzhong@2x.png"/>
            <van-field v-model="workTypesText" label="招工工种：" right-icon="arrow" placeholder="请选择工种"
                       input-align="left" readonly @click="workTypesMethods"/>
          </div>
          <div class="fex">
            <van-icon
              name="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_renshu@2x.png"/>
            <van-field v-model="form.requiedWorkerNum" label="招工人数：" placeholder="请输入招工人数" input-align="left"
                       type="digit" maxlength="8"/>
          </div>

        </div>
      </div>

      <div class="btn-div">
        <van-button round block color="#096CEF" type="info" @click="publishSubmit">立即发布</van-button>
      </div>

    </div>

    <div class="selectCompany" v-if="showSelect">
      <van-sticky>
        <div class="overlay-div"></div>
        <div class="van-sticky-div">
          <div class="basic radios">
            <van-radio-group v-model="radio">
              <van-radio name="1">所有人员</van-radio>
              <van-radio name="2">部分人员</van-radio>
            </van-radio-group>
          </div>
          <div v-show="radio == 2" class="tag">
            <div v-for="(item, index) in checkedList" :key="index" class="personStyle">
              <span>{{ item.name }}</span>
              <van-icon class="icon-del" name="clear" @click="closeTag(item)"/>
            </div>
          </div>
          <div v-show="radio == 2" class="search">
            <form action="/">
              <van-search v-model="searchValue" placeholder="请输入名称" @input="onSearch"/>
            </form>
          </div>
        </div>
      </van-sticky>
      <div v-if="radio == 2">
        <div class="index-bar">
          <van-index-bar :sticky-offset-top='0' :sticky="false">
            <div class="product">
              <div class="product" v-for="(item, index) in companyList" :key="index">
                <div v-if="item.list.length > 0">
                  <van-index-anchor :index="item.headLetter"/>
                  <van-checkbox-group v-model="companyIds" v-for="(item1, index) in item.list" :key="item1.id">
                    <van-checkbox shape="square" :name="item1.id" @click="toggle(item1)">{{ item1.name }}</van-checkbox>
                  </van-checkbox-group>
                </div>
              </div>
            </div>
          </van-index-bar>
        </div>

      </div>
      <div class="submit">
        <van-button type="info" block @click="confirm">确定</van-button>
      </div>
    </div>

    <!--派活流程-->
    <van-popup v-model="isAssignProcessShow" position="bottom">
      <van-picker
        title="请选择"
        show-toolbar
        :columns="typeList"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>

    <!--工种-->
    <van-popup v-model="gongZhongIsShow" class="gongZhongBox" position="bottom"
               :style="{ height: '100%',width: '100%' }">
      <selectGongZhongOption @closeGongZhong="closeGongZhong" :workTypesList="workTypesList" ref="selectGongZhong"
                             @close="closeInit"/>
    </van-popup>

    <!--信息有效期-->
    <van-popup v-model="validDaysIsShow" position="bottom">
      <van-picker
        title="请选择"
        show-toolbar
        value-key="name"
        :default-index="0"
        :columns="validDaysList"
        @confirm="validDaysOnConfirm"
        @cancel="validDaysOnCancel"
      />
    </van-popup>

    <!--时间-->
    <van-popup v-model="isShow" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        title="请选择时间"
        :formatter="formatter"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="isShow = false"
        @confirm="confirmPicker"
      />
    </van-popup>

    <!--内容存在违规词的提示-->
    <van-dialog v-model="violationShow" title="内容存在违规词" :showConfirmButton="false" :closeOnClickOverlay="true">
      <div class="violation-div">{{ illegalWords }}</div>
      <div class="bt_H_35 bt_w_125 mb_center">
        <van-button type="info" round @click="violationShow = false">修改</van-button>
      </div>
    </van-dialog>

    <van-dialog
      style="width:100%;border-radius:0;height:200px"
      theme="default"
      v-model="showvideoplay"
      :show-cancel-button="false"
      :show-confirm-button="false"
      closeOnClickOverlay
    >

      <div ref="videobox" id="mui-player"></div>
    </van-dialog>
    <div id="video-ios" style="height: 0"></div>
  </div>
</template>

<script>
import areaList from '@/libs/area'
import { typeList, validDaysList } from '@/libs/enumerates'
import { projectPub, getCompanyByLetter, pubTempelte } from '@api/invitationBids'
import { getWorkList } from '@api/recommend'
import { ossBrowse } from '@api/oss'
import selectGongZhongOption from '@/components/selectGongZhongOption'
import { illegalWordsCheck, typeOfWorkMatch } from '@api//project'
import { dataSave } from '@api/coins'
import create_button_close from '../../assets/images/distribution/create_button_close.png'
import 'mui-player/dist/mui-player.min.css'
import MuiPlayer from 'mui-player'
import { ImagePreview } from 'vant'

export default {
  name: 'publishPage',
  components: {
    selectGongZhongOption
  },
  data () {
    return {
      create_button_close: create_button_close,
      illegalWords: '',
      violationShow: false,
      areaList: areaList, // 城市
      showall: false,
      checkedList: [],
      showSelect: false,
      radio: '1',
      companyList: [],
      companyIds: [],
      form: {
        city: '',
        lng: '',
        lat: '',
        type: '2', // 流程
        typeText: '简易流程',
        validDays: '15', // 信息有效期
        validDaysText: '',
        companyRangeStr: '所有人员',
        intro: '',
        // 给空字符串，不然 show-word-limit 属性的length会报错
        name: ''
      },
      minDate: new Date(),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      fileList: [],
      attachs: [],
      typeList: typeList, // 流程list
      isAssignProcessShow: false, // 流程选择的弹窗

      gongZhongList: [], // 工种选项list
      gongZhongIsShow: false, // 工种弹窗
      workTypes: [], // 工种id
      workTypesText: '', // 工种名称
      workTypesList: [],
      isActive: '',

      validDaysList: validDaysList, // 信息有效期list
      validDaysIsShow: false, // 信息有效期弹窗

      isShow: false, // 出生日期组件显示或隐藏
      timeType: '', // 时间type
      searchValue: '',
      ossData: {},
      // 地区
      currentCity: [],
      addressName: '正在获取当前位置.....',
      lng: '',
      lat: '',
      tempelteList: [], // 模板列表
      muBanIsShow: false,
      videourl: '',
      showvideoplay: false,
      tempelteIndex: 0,
      isClearMuban: false
    }
  },
  created () {
    this.initLocation()
    this.startTime = Date.now()

    this.$bridge.callHandler('cityResult', response => {
      console.log('response:', response)
    })

    // 获取定位地区
    this.$bridge.registerHandler('cityResult', (data, responseCallback) => {
      if (data === '-1') {
        this.addressName = '获取定位失败'
        this.$toastMsg('定位服务未开启，请手动开启')
        return
      }
      const arr = data.split(',')
      let lng = arr[0]
      let lat = arr[1]
      let addressName = arr[2]
      // 获取客户端传递的定位
      if (lng === 'undefined' && lat === 'undefined') {
        this.initLocation()
      } else if (lng == 0.0 && lat == 0.0) {
        this.addressName = '获取定位失败'
        this.$toastMsg('应用需要定位权限，请手动开启')
      } else if (lng == 'null' && lat == 'null') {
        this.addressName = '获取定位失败'
        this.$toastMsg('应用需要定位权限，请手动开启')
      } else if (lng === null && lat === null) {
        this.addressName = '获取定位失败'
        this.$toastMsg('应用需要定位权限，请手动开启')
      } else if (lng === '' && lat === '') {
        this.addressName = '获取定位失败'
        this.$toastMsg('应用需要定位权限，请手动开启')
      } else if (lng && lat) {
        this.form.lng = lng
        this.form.lat = lat

        this.lng = lng
        this.lat = lat

        this.addressName = addressName

        // 根据经纬度获取当前定位城市
        let lngLat = []
        lngLat.push(this.form.lng)
        lngLat.push(this.form.lat)
        this.getCityCode(lngLat)
      } else {
        this.addressName = '获取定位失败'
        this.$toastMsg('应用需要定位权限，请手动开启')
      }
      responseCallback(data)
    })

    // 客户端调用js方法-语音输入
    this.$bridge.registerHandler('SpeechInput', (data, responseCallback) => {
      this.form.intro = this.form.intro + data
      this.typeOfWorkMatchMethod()
      responseCallback(data)
    })

    // 客户端调起关闭弹窗事件
    this.$bridge.registerHandler('closePopup', (data, responseCallback) => {
      this.showSelect = false
      responseCallback(data)
    })

    // 客户端调起上传成功解密事件
    this.$bridge.registerHandler('decodeMethod', (data, responseCallback) => {
      this.decodeMethod(data)
      responseCallback(data)
    })

    // 发布招工页面，通知客户端，关闭侧滑，点击左上角返回引导用户继续填写
    this.$bridge.callHandler('closeSideslip', response => {
      console.log('response:', response)
    })

    // 初始化极光统计
    this.$jiguang.initCountEvent()

    // 地址回调
    this.$bridge.registerHandler('mapChosenBack', (data, responseCallback) => {
      const arr = data.split(',')

      if (arr && arr.length > 1) {
        this.form.lng = arr[0]
        this.form.lat = arr[1]
        this.addressName = arr[2]

        // 根据经纬度获取当前定位城市
        let lngLat = []
        lngLat.push(this.form.lng)
        lngLat.push(this.form.lat)
        this.getCityCode(lngLat)
      }

      responseCallback(data)
    })

    // 设置默认截止时间
    let date = new Date() // 获取当前时间
    // 这里的60就是你要加的天数，减也可以。年、月会相应加上去，值得注意的是date.getMonth()得到的月份比实际月份小1，所以实际月份是(date.getMonth()+1)
    date.setDate(date.getDate() + 15) // 获取N天后的日期
    this.form.validDaysText = this.timeFormat(date)
  },

  mounted () {
    setTimeout(function () {
      if (this.lng && this.lng != 'undefined') {
        this.initLocation()
      }
    }, 3000)
    // 获取数据
    this.getWorkList()
    this.timeFormat(new Date())// 获取选择队伍信息
  },
  methods: {
    // 验证是否含有敏感词
    illegalWordsCheck () {
      illegalWordsCheck({
        text: this.form.name + ',' + this.form.intro
      }).then(res => {
        if (res.data.code === 200) {
          if (res.data.data.contains == 1) {
            this.illegalWords = '您发布的招工信息内容存在敏感词汇，请修改后再发'//res.data.data.illegalWords
            this.violationShow = true
          } else {
            this.submitMethods()
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    // 查询所关联工种
    typeOfWorkMatchMethod () {
      typeOfWorkMatch({
        text: this.form.intro
      }).then(res => {
        if (res.data.code === 200) {
          if (res.data.data.length > 0) {
            if (this.workTypesList.length > 0) {
              const workTypesList = res.data.data.concat(this.workTypesList)
              let forData = []
              for (let i = 0; i < workTypesList.length; i++) {
                if (!forData.some(e => e.id == workTypesList[i].id)) forData.push(workTypesList[i])
              }
              this.workTypesList = forData
            } else {
              this.workTypesList = res.data.data
            }
            this.workTypesText = (this.workTypesList.map(item => item.name)).toString()
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 语音输入
    btn_voice () {
      this.$bridge.callHandler('SpeechInput', response => {
        console.log('response:', response)
      })
    },

    // 模板输入
    btn_muban () {
      pubTempelte({
        pubType: 1
      }).then(res => {
        if (res.data.code === 200) {
          this.tempelteList = res.data.data
          if (res.data.data.length > 1) {
            this.muBanIsShow = true
            this.tempelteIndex = 0
            this.form.intro = res.data.data[0].label
          } else {
            this.form.intro = res.data.data[0].label
            this.isClearMuban = true
          }
          document.getElementById('introFocus').focus()
          // 解析工种
          this.typeOfWorkMatchMethod()
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    btn_clearMuban () {
      this.form.intro = ''
      this.isClearMuban = false
    },
    shangyige () {
      if (this.tempelteIndex === 0) {
        this.tempelteIndex = this.tempelteList.length - 1
        this.form.intro = this.tempelteList[this.tempelteIndex].label
      } else {
        this.tempelteIndex = this.tempelteIndex - 1
        this.form.intro = this.tempelteList[this.tempelteIndex].label
      }
      // 解析工种
      this.typeOfWorkMatchMethod()
    },
    xiayige () {
      if (this.tempelteIndex === this.tempelteList.length - 1) {
        this.tempelteIndex = 0
        this.form.intro = this.tempelteList[0].label
      } else {
        this.tempelteIndex = this.tempelteIndex + 1
        this.form.intro = this.tempelteList[this.tempelteIndex].label
      }
      // 解析工种
      this.typeOfWorkMatchMethod()
    },
    btn_map () {
      const data = {
        url: `${process.env.VUE_APP_BASE_HOST}/mapLocation?lng=` + this.lng + '&lat=' + this.lat,
        title: '选择地址'
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
      // this.enterRouter('mapLocation')
    },
    // 流程弹窗打开
    assignProcess () {
      this.isAssignProcessShow = true
    },
    // 流程弹窗确定
    onConfirm (value) {
      this.form.type = value.id
      this.form.typeText = value.text
      if (this.form.type === '2') {
        this.form.signInBeginTime = ''
        this.form.signInEndTime = ''
        this.form.tenderEndTime = ''
        this.form.bidOpeningTime = ''
        this.form.requiedFinishTime = ''
      } else {
        this.workTypes = []

        this.form.validDays = '15'
        // 设置默认截止时间
        let date = new Date() // 获取当前时间
        // 这里的60就是你要加的天数，减也可以。年、月会相应加上去，值得注意的是date.getMonth()得到的月份比实际月份小1，所以实际月份是(date.getMonth()+1)
        date.setDate(date.getDate() + 15) // 获取N天后的日期
        this.form.validDaysText = this.timeFormat(date)

        this.workTypesList = []
        this.workTypesText = ''
      }
      this.isAssignProcessShow = false
    },
    // 流程弹窗取消
    onCancel () {
      this.isAssignProcessShow = false
    },
    // 打开工种弹窗
    workTypesMethods () {
      this.gongZhongIsShow = true
      this.$nextTick(() => {
        this.$refs.selectGongZhong.initPage()
      })
    },
    // 关闭按钮
    closeGongZhong (data) {
      this.gongZhongIsShow = false
      this.workTypesList = data
      this.workTypesText = (data.map(item => item.name)).toString()
    },
    closeInit () {
      this.gongZhongIsShow = false
    },
    // 信息有效期弹窗打开
    validDaysMethods () {
      this.validDaysIsShow = true
    },
    // 点击确定信息有效期
    validDaysOnConfirm (value) {
      if (value !== '永久') {
        let date = new Date() // 获取当前时间
        // 这里的60就是你要加的天数，减也可以。年、月会相应加上去，值得注意的是date.getMonth()得到的月份比实际月份小1，所以实际月份是(date.getMonth()+1)
        date.setDate(date.getDate() + Number(value)) // 获取N天后的日期
        this.form.validDaysText = this.timeFormat(date)
        this.form.validDays = value
      } else {
        this.form.validDaysText = '永久有效'
        this.form.validDays = '永久有效'
      }
      this.validDaysIsShow = false
    },

    validDaysOnCancel () {
      this.validDaysIsShow = false
    },

    // 获取工种
    getWorkList () {
      getWorkList().then(res => {
        if (res.data.code === 200) {
          this.gongZhongList = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    formatter (type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      } else if (type === 'day') {
        return `${val}日`
      } else if (type === 'hour') {
        return `${val}时`
      } else if (type === 'minute') {
        return `${val}分`
      }
      return val
    },
    // 时间类型
    typeTime (type) {
      this.isShow = true
      this.timeType = type
    },
    confirmPicker (val) {
      this.isShow = false
      if (this.timeType === 'signInBeginTime') {
        // 报名开始时间
        this.form.signInBeginTime = this.timeFormat(val)
      } else if (this.timeType === 'signInEndTime') {
        // 报名截止时间
        this.form.signInEndTime = this.timeFormat(val)
      } else if (this.timeType === 'tenderEndTime') {
        // 投标截止时间
        this.form.tenderEndTime = this.timeFormat(val)
      } else if (this.timeType === 'bidOpeningTime') {
        // 开标时间
        this.form.bidOpeningTime = this.timeFormat(val)
      } else if (this.timeType === 'requiedFinishTime') {
        // 项目计划完工时间
        this.form.requiedFinishTime = this.timeFormat(val)
      }
    },
    // 提交之前的校验
    publishSubmit () {
      if (this.form.type === '1') {
        if (!this.form.intro) {
          this.$toast.fail('请输入项目内容')
          return false
        } else if (!this.form.signInBeginTime) {
          this.$toast.fail('请选择报名开始时间')
          return false
        } else if (!this.form.signInEndTime) {
          this.$toast.fail('请选择报名截止时间')
          return false
        } else if (!this.form.tenderEndTime) {
          this.$toast.fail('请选择投标截止时间')
          return false
        } else if (!this.form.bidOpeningTime) {
          this.$toast.fail('请选择开标时间')
          return false
        } else {
          const signInBeginTime = new Date(this.form.signInBeginTime.replace(/-/g, '/')).getTime()
          const signInEndTime = new Date(this.form.signInEndTime.replace(/-/g, '/')).getTime()
          const tenderEndTime = new Date(this.form.tenderEndTime.replace(/-/g, '/')).getTime()
          const bidOpeningTime = new Date(this.form.bidOpeningTime.replace(/-/g, '/')).getTime()
          if (signInBeginTime >= signInEndTime) {
            this.$toast.fail('报名截止时间要大于报名开始时间')
            return false
          } else if (signInEndTime > tenderEndTime) {
            this.$toast.fail('投标截止时间要大于等于报名截止时间')
            return false
          } else if (tenderEndTime > bidOpeningTime) {
            this.$toast.fail('开标时间要大于等于投标截止时间')
            return false
          } else if (this.form.requiedFinishTime) {
            const requiedFinishTime = new Date(this.form.requiedFinishTime.replace(/-/g, '/')).getTime()
            if (bidOpeningTime > requiedFinishTime) {
              this.$toast.fail('项目计划完工时间要大于开标时间')
              return false
            } else {
              this.illegalWordsCheck()
            }
          } else {
            this.illegalWordsCheck()
          }
        }
      } else {
        // 简易流程
        if (!this.form.intro) {
          this.$toast.fail('请输入项目内容')
          return false
        }
        if (this.form.intro.length < 5) {
          this.$toast.fail('项目内容最少5个字')
          return false
        } else if (this.workTypesList.length == 0) {
          this.$toast.fail('请选择工种')
          return false
        } else if (this.workTypesList.length > 5) {
          this.$toast.fail('最多选择5个工种')
          return false
        } else {
          this.illegalWordsCheck()
        }
      }
    },
    // 提交数据
    submitMethods () {
      let browTime = parseInt((Date.now() - this.startTime) / 1000)
      let brow = 'h5_publish_zhaogong_browser,发布招工信息,招工,' + browTime
      // 初始化极光统计预览时长
      this.$jiguang.initBrowseEvent(brow)
      // 获取极光统计所需数据
      this.$bridge.callHandler('getDeviceInfo', 'h5_publish_zhaogong', response => {
        console.log('response:', response)
      })

      let data = {}

      data.companyIds = this.companyIds.toString()
      if (this.form.type == '2') {
        if (this.form.validDaysText === '永久有效' || this.form.validDays === 0) {
          this.form.validDays = 0
          this.form.signInEndTime = '2099.12.31 23:59'
        } else {
          this.form.signInEndTime = this.form.validDaysText
        }
      }
      data.project = this.form
      data.project.address = this.addressName
      data.attachs = this.attachs
      data.type = this.$route.query.type // 找活类型
      data.workTypes = (this.workTypesList.map(item => item.id)).join(',') // 工种

      let dataJson = {
        typeWorks: this.workTypesList,
        userCities: this.userCities,
      }

      projectPub(data).then(res => {
        if (res.data.code === 200) {
          this.$bridge.callHandler('backRefreshMark', response => {
            console.log('response:', response)
          })
          this.form = {
            city: '',
            lng: '',
            lat: '',
            type: '2', // 流程
            typeText: '简易流程',
            validDays: '15', // 信息有效期
            companyRangeStr: '所有人员',
            intro: '',
            // 给空字符串，不然 show-word-limit 属性的length会报错
            name: ''
          }
          this.$bridge.callHandler('cityResult', response => {
            console.log('response:', response)
          })
          // 设置默认截止时间
          let date = new Date() // 获取当前时间
          // 这里的60就是你要加的天数，减也可以。年、月会相应加上去，值得注意的是date.getMonth()得到的月份比实际月份小1，所以实际月份是(date.getMonth()+1)
          date.setDate(date.getDate() + 15) // 获取N天后的日期
          this.form.validDaysText = this.timeFormat(date)

          this.workTypesList = []
          this.attachs = []
          this.workTypesText = ''
          // 删除缓存
          localStorage.removeItem('checkedList')
          localStorage.removeItem('companyJson')

          // 发布成功后解除返回限制
          this.$bridge.callHandler('openSideslip', response => {
            console.log('response:', response)
          })

          let id = res.data.data
          // 暂时储存临时数据
          dataSave(dataJson).then(res => {
            if (res.data.code === 200) {
              const data = {
                url: `${process.env.VUE_APP_BASE_HOST}/recruitPublishSuccess?id=${id}&uid=${res.data.data}`,
                title: '发布成功'
              }
              this.$bridge.callHandler('newPage', data, response => {
                console.log('response:', response)
              })
            }
          })

        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    // 跳转选择招标队伍页面
    toSelectCompany () {
      this.getCompanyByLetter()
      this.showSelect = true
      this.$bridge.callHandler('showPopup', response => {
        console.log('response:', response)
      })
    },

    // ---------------------------------选择相关---------------------------------------
    // 获取队伍列表数据
    getCompanyByLetter () {
      const data = {}
      data.name = this.searchValue
      getCompanyByLetter(data).then(res => {
        if (res.data.code === 200) {
          this.companyList = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    onSearch () {
      // 获取数据
      this.getCompanyByLetter()
    },

    // 复选框选择
    toggle (e) {
      let companyId = e.id
      let index = this.checkHasCompany(companyId)
      if (index > -1) {
        this.checkedList.splice(index, 1)
        return
      }
      this.checkedList.push(e)
    },

    // 验证选中队伍，如果已选中，返回下标；
    checkHasCompany (companyId) {
      let checkedList = this.checkedList
      for (let i = 0; i < checkedList.length; i++) {
        if (checkedList[i].id === companyId) {
          return i
        }
      }
      return -1
    },

    // 验证选中队伍，如果已选中，返回下标；
    checkHasCompanyId (companyId) {
      let companyIds = this.companyIds
      for (let i = 0; i < companyIds.length; i++) {
        if (companyIds[i] === companyId) {
          return i
        }
      }
      return -1
    },

    closeTag (e) {
      let companyId = e.id
      let index = this.checkHasCompany(companyId)
      if (index > -1) {
        this.checkedList.splice(index, 1)
      }
      var companyIdIndex = this.checkHasCompanyId(companyId)
      if (companyIdIndex > -1) {
        this.companyIds.splice(companyIdIndex, 1)
      }
    },
    // 提交
    confirm () {
      if (this.radio == 2 && this.companyIds.length < 3) {
        this.$toast.fail('最少选择3个队伍')
        return
      }
      var companyRange = this.radio
      this.form.companyRange = companyRange
      if (companyRange == 1) {
        this.form.companyRangeStr = '所有人员'
        this.companyIds = []
        this.checkedList = []
      } else {
        this.form.companyRangeStr = '部分人员'
      }
      this.showSelect = false
      this.$bridge.callHandler('closePopup', response => {
        console.log('response:', response)
      })
    },

    initLocation () {
      var that = this
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          // locationSuccess 获取成功的话
          function (position) {
            that.lng = position.coords.longitude
            that.lat = position.coords.latitude
            that.form.lng = position.coords.longitude
            that.form.lat = position.coords.latitude
            let lnglat = []
            lnglat.push(that.lng)
            lnglat.push(that.lat)
            that.getLocation(lnglat)
            that.getCityCode(lnglat)
          },
          // locationError  获取失败的话
          function (error) {
            // 定位出错
            that.addressName = '获取定位失败'
          }
        )
      } else {
        // 定位出错
        that.addressName = '获取定位失败'
      }
    },

    // 获取地址
    getLocation (lnglat) {
      const that = this
      var geocoder = new AMap.Geocoder({})
      geocoder.getAddress(lnglat, function (status, data) {
        if (status === 'complete' && data.info === 'OK') {
          // result为对应的地理位置详细信息
          that.addressName = data.regeocode.formattedAddress
        }
      })
    },

    // 获取地址
    getCityCode (lnglat) {
      let that = this
      var geocoder = new AMap.Geocoder({})
      geocoder.getAddress(lnglat, function (status, data) {
        if (status === 'complete' && data.info === 'OK') {
          let city = data.regeocode.addressComponent.city
          if (!city) {
            city = data.regeocode.addressComponent.province
          }

          // 判断是否是直辖市，如果是+0100
          let citys = '11,12,31,50,71,81,82'
          let code = data.regeocode.addressComponent.adcode.slice(0, 2)
          let cityid

          if (citys.indexOf(code) > -1) {
            cityid = code + '0100'
          } else {
            cityid = data.regeocode.addressComponent.adcode.slice(0, 4) + '00'
          }
          that.userCities = [{
            city: city,
            cityid: cityid,
            province: data.regeocode.addressComponent.province,
            provinceid: data.regeocode.addressComponent.adcode.slice(0, 2) + '0000'
          }]

          that.form.city = cityid
        }
      })
    },

    upload () {
      const data = {
        bucket: 'yiyong-pub',
        path: 'project/bidding/',
        type: 1 // 0-不上传文件，1-上传文件
      }
      this.$bridge.callHandler('uploadMethod', data, response => {
        console.log('response:', response)
      })
    },
    // 解密
    decodeMethod (data) {
      this.attachs.push({
        attachName: (decodeURIComponent(data)).substring(data.lastIndexOf('/') + 1),
        attachUrl: data,
        fileType: data.substring(data.lastIndexOf('.') + 1) // 文件后缀名
      })
      this.$toastMsg('上传成功')
    },
    // 下载附件
    attachsDetail (attachUrl) {
      this.$bridge.callHandler('newPage', { url: attachUrl }, response => {
        console.log('response:', response)
      })
    },
    attachDelete (index) {
      this.attachs.splice(index, 1)
    },
    // 下载附件
    attDetail (file, index) {

      if (file.fileType === 'mp4') {
        // 判断ios还是安卓
        const u = navigator.userAgent
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        if (isiOS) {

          const video = document.getElementById('playVideos')
          if (video) {
            video.remove()
          }

          let str = document.createElement('video')
          str.id = 'playVideos'
          str.src = file.attachUrl
          str.setAttribute('type', 'video/mp4')
          str.setAttribute('controls', 'controls')
          str.style.width = '0'
          str.style.height = '0'
          str.play()
          document.getElementById('video-ios').append(str)
        } else {
          this.$bridge.callHandler('newPage', { url: file.attachUrl }, response => {
            console.log('response:', response)
          })
          return
          this.showvideoplay = true

          setTimeout(function () {
            // 初始化 MuiPlayer 插件，MuiPlayer 方法传递一个对象，该对象包括所有插件的配置
            var mp = new MuiPlayer({
              container: '#mui-player',
              title: '视频',
              src: file.attachUrl,
              preload: 'auto',
              autoplay: true
            })
          }, 500)
        }
      } else {
        let list = []
        for (let i = 0; i < this.attachs.length; i++) {
          if (this.attachs[i].fileType !== 'mp4') {
            list.push(this.attachs[i].attachUrl)
          } else {
            if (i <= index) {
              index = index - 1
            }
          }
        }

        ImagePreview({
          images: list,
          showIndex: true,
          loop: false,
          startPosition: index
        })
      }
    },

  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";

.publishPage {
  padding-bottom: 70px;

  .fileContainerBox {
    display: flex;
    align-items: center;
    width: auto;
  }

  .fileBox {
    display: flex;
    flex-wrap: wrap;

    .file-img {
      width: 80px;
      height: 80px;
      margin-top: 10px;
      margin-left: 10px;
      flex-shrink: 0;
    }

    .videoBox {
      width: 80px;
      height: 80px;
      margin-top: 10px;
      margin-left: 10px;
    }

    .icon_video_bg {
      width: 80px;
      height: 80px;
      position: absolute;
      top: 0px;
      left: 0;
      z-index: 0;
    }

    .video {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }

    .icon-attachDelete {
      font-size: 19px;
      color: #FFFFFF;
      position: absolute;
      top: 12px;
      right: 0;
    }
  }

  .pad12 {
    margin: 12px;
  }

  .pubWorkerHeadTitle {
    span {
      color: #333;
      @include add_size($font_size_16);
      vertical-align: middle;
      margin-left: 4px;
      font-weight: bold;
    }

    .van-icon {
      vertical-align: middle;
      @include add_size($font_size_22);
    }

    .blue {
      color: #096CEF;
    }
  }

  .GongZhongList {
    width: 82% !important;
  }

  .icon-right {
    top: 4px;
  }

  .borderBottom {
    border-bottom: 1px solid #eee;
  }

  .btn-div {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 60px;
    bottom: 0;
    background: #fff;
    text-align: center;

    .van-button {
      height: 36px;
      line-height: 36px;
      @include add_size($font_size_17);
      width: 80%;
    }
  }
}

.selectCompany {
  padding-bottom: 90px;

  .submit {
    margin-left: 10%;
    bottom: 20px;
    width: 80%;
    margin-top: 25px;
    position: fixed;
  }
}

.checkbox-group {
  padding-left: 0.66667rem;
}

.selectCompany {
  @include add_size($font_size_16);
}

.van-radio, .van-checkbox {
  padding: 0.2rem 0;
}

.to-select {
  padding: 10px 0;
  color: #009CFF;
}

.van-index-bar .van-cell {
  padding: 0.4rem 0.42667rem;
}

.van-checkbox-group {
  background-color: #fff;
  @include add_size($font_size_16);
}

.van-checkbox {
  padding: 0.3rem 0.42667rem;
  @include add_size($font_size_16);
  color: #333;
}

.van-sticky-div {
  background-color: #f7f7f7;
}

.tag {
  padding: 0 10px 10px 10px;
  z-index: 2;
  max-height: 250px;
  overflow: auto
}

.personStyle {
  @include add_size($font_size_18);
  text-align: center;
  border-radius: 20px;
  background: #EEEEEE;
  margin-bottom: 10px;
  padding: 10px;

  .icon-del {
    vertical-align: middle;
    padding-left: 5px;
    padding-bottom: 3px;
    font-size: 22px;
    color: #999999;
  }
}

.van-tag {
  font-size: 18px;
}

.overlay-div {
  height: 20px;
  background-color: #666666
}

.moreSettings {
  @include add_size($font_size_20);
  color: #333;
  font-weight: bold;
  margin-bottom: 18px;
}

.moreSettings.retract:after {
  vertical-align: text-bottom;
  content: "";
  display: inline-block;
  width: 9px;
  height: 9px;
  border-width: 1px 1px 0 0;
  border-style: solid;
  margin-left: 14px;
  transform: translate(-50%, -50%) rotate(-45deg);
}

.moreSettings.open:after {
  vertical-align: middle;
  content: "";
  display: inline-block;
  width: 9px;
  height: 9px;
  border-width: 0 0 1px 1px;
  border-style: solid;
  margin-left: 14px;
  transform: translate(-50%, -50%) rotate(-45deg);
}

.companyListStyle {
  .title {
    @include add_size($font_size_20);
    font-weight: bold;
    color: #333;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 30px;
  }

  .van-cell {
    display: flex;
    width: 60%;
    margin: 0 auto;
    padding: 0;
    align-items: center;
  }

  .van-hairline--top-bottom::after {
    display: none;
  }

  .companySubmit {
    width: 84%;
    margin: 0 auto;
    margin-top: 40px;
    margin-bottom: 30px;
  }
}

.active {
  background-color: #0368C1 !important;
  color: #fff !important;
}

.btn_map {
  width: 122px;
  height: 22px;
  margin-top: -34px;
}

.icon_dizhi {
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
}

.icon_dizhiBox {
  @include add_size($font_size_17);
  vertical-align: middle;
  color: #333333;
}

.btn_shangchuang {
  width: 57px;
  height: 22px;
  margin-top: -34px;
}
</style>
<style lang="scss">
@import "../../assets/css/mixin";

.publishPage {
  #mui-player {
    height: 200px !important;
  }

  .van-field__control {
    @include add_size($font_size_16);
    line-height: 26px;
  }

  .van-cell__value {
    color: #999;
  }

  .inlineStyleBox {
    padding: 12px 6px 12px 8px;

    .van-field__label {
      display: inline-block;
      width: 6em;
      margin-right: 0;
      font-weight: bold;
    }

    .van-cell__value {
      display: inline-block;
    }

    .van-cell {
      display: flex;
      align-items: center;
      background-color: #EFF6FF;
      border: 1px solid #7EC3FF;
      border-radius: 5px;
      padding: 10px;
      margin-left: 6px;
    }

    .van-icon {
      @include add_size($font_size_20);
      vertical-align: middle;
    }

    .fex {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
    }
  }
}

.projectContent {
  position: relative;

  .van-cell {
    padding-bottom: 0 !important;
  }

  .van-field__control {
    background: #EFF6FF;
    padding: 10px;
  }

  .btn_voiceBox {
    height: 45px;
    background: #EFF6FF;
    display: flex;
    justify-content: flex-end;
    padding: 0 10px;

    .van-button {
      width: 144px;
      height: 32px;

      .van-button__text {
        @include add_size($font_size_14);
      }

      &:last-child {
        float: right;
      }
    }
  }

  .btn_voiceStyle {
    height: 45px;
    background: #EFF6FF;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;

    .van-button {
      width: 144px;
      height: 32px;

      .van-button__text {
        @include add_size($font_size_14);
      }

      &:last-child {
        float: right;
      }
    }
  }

  .muBanIsShow {
    background: #EFF6FF;
    display: flex;
    justify-content: center;
    padding: 16px;

    img {
      width: 65px;
      height: 21px;

      &:first-child {
        margin-right: 28px;
      }
    }
  }
}
</style>
